import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  container: props => ({
    width: props.width,
    height: props.height
  }),
  st0: {
    fill: "#cee0e9"
  },
  st1: {
    fill: "none",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  },
  st2: {
    fill: "#8db8cb",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }
});

const IndiaOutlineIcon = props => {
  const classes = useStyles(props);

  return (
    <SvgIcon
      viewBox="0 0 80 80"
      className={classNames(classes.container, props.className)}
    >
      <polygon
        className={classes.st0}
        points="10.1,41.4 3.7,34.5 0,34.2 0,0 80,0 80,59.9 77.5,58.6 74.6,59.8 72.1,58.4 70.9,50.9 67.2,46.9 
	61.8,44.2 59.9,44.2 57.1,33.1 62.7,33.1 62.7,35.9 65.4,35.9 65.4,41.4 68.2,44.2 68.2,38.6 71,38.6 73.7,30.3 79.3,27.6 
	76.5,24.8 71,24.8 68.2,27.6 68.2,30.3 59.9,30.3 59.9,27.6 57.1,27.6 57.1,30.3 48.8,30.3 37.8,27.6 40.5,22 35,19.3 35,16.5 
	37.8,16.5 37.8,11 40.5,8.2 37.8,5.4 32.2,8.2 26.7,2.6 21.2,2.6 21.2,5.4 23.9,8.2 23.9,13.7 26.7,16.5 21.2,27.6 15.6,27.6 
	12.8,30.3 15.6,35.9 10.1,38.6 "
      />
      <polyline className={classes.st1} points="10.1,41.4 3.7,34.5 0,34.2 " />
      <polyline
        className={classes.st1}
        points="80,59.9 77.5,58.6 74.6,59.8 72.1,58.4 70.9,50.9 67.2,46.9 61.8,44.2 59.9,44.2 "
      />
      <polygon
        className={classes.st2}
        points="76.5,24.8 71,24.8 68.2,27.6 68.2,30.3 59.9,30.3 59.9,27.6 57.1,27.6 57.1,30.3 48.8,30.3 37.8,27.6 
	40.5,22 35,19.3 35,16.5 37.8,16.5 37.8,11 40.5,8.2 37.8,5.4 32.2,8.2 26.7,2.6 21.2,2.6 21.2,5.4 23.9,8.2 23.9,13.7 26.7,16.5 
	21.2,27.6 15.6,27.6 12.8,30.3 15.6,35.9 10.1,38.6 10.1,41.4 15.6,46.9 18.4,46.9 21.2,44.2 21.2,55.2 32.2,77.4 37.8,71.9 
	37.8,58 43.3,55.2 54.4,44.2 59.9,44.2 57.1,33.1 62.7,33.1 62.7,35.9 65.4,35.9 65.4,41.4 68.2,44.2 68.2,38.6 71,38.6 73.7,30.3 
	79.3,27.6 "
      />
    </SvgIcon>
  );
};

IndiaOutlineIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};

export default IndiaOutlineIcon;
